import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Badge, Button, Col, Row, Table } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { get } from '../../utils';
import './style.scss';

const HollandResult = ({ score }) => {
  const endPageRef = useRef(null);
  const history = useHistory();
  const [bestScore, setBestScore] = useState(0);

  useEffect(() => {
    const getBestScore = Object.keys(score).sort((a, b) => score[a] - score[b]);
    setBestScore(parseInt(getBestScore.pop(), 10));
    // eslint-disable-next-line no-unused-expressions
    endPageRef?.current?.scrollIntoView({ behavior: 'smooth', duration: 2500 });
  }, [score]);

  const handleBack = () => {
    history.replace('/');
  };
  const renderResult = () => {
    let result = {};
    switch (bestScore) {
      case 1:
        result = {
          name: 'Nhóm 1: Nhóm Kỹ Thuật- Người hành động',
          description: `Đây là những người thích vận động thể thao hoặc
          có khả năng làm việc tốt với máy móc, vật thể,
          công cụ, cây cảnh hoặc con vật, hoặc thích làm
          việc ngoài trời.`
        };
        break;
      case 2:
        result = {
          name: 'Nhóm 2: Nhóm Nghiên cứu - Người tư duy',
          description: `Đây là những người thích quan sát, học hỏi, tìm
          hiểu, tra cứu, phân tích, đánh giá và giải quyết vấn
          đề.`
        };
        break;
      case 3:
        result = {
          name: 'Nhóm 3: Nghệ thuật - Người kiến tạo',
          description: `Đây là những người có khả năng nghệ thuật, cải
          tiến, trực giác và thích làm việc trong các tình
          huống không có kế hoạch trước như dùng trí
          tưởng tượng và sáng tạo.`
        };
        break;
      case 4:
        result = {
          name: 'Nhóm 4: Nhóm Xã Hội - Người giúp đỡ',
          description: `Đây là những người thích làm việc với con người,
          thích soi sáng, giúp đỡ, truyền đạt thông tin, huấn
          luyện hoặc chữa trị cho người khác hoặc có kỹ
          năng về ngôn ngữ.`
        };
        break;
      case 5:
        result = {
          name: 'Nhóm 5: Quản lý - Người thuyết phục',
          description: `Đây là những người thích làm việc với con người,
          thích ảnh hưởng, thuyết phục, thể hiện, lãnh đạo
          hoặc quản lý con người vì các mục tiêu của tổ
          chức hoặc lợi ích kinh tế.`
        };
        break;
      case 6:
        result = {
          name: 'Nhóm 6: Nghiệp vụ - Người sắp xếp',
          description: `Đây là những người thích làm việc với dữ liệu, có
          kỹ năng làm việc với con số và công việc lưu trữ,
          văn thư, thực hiện nhiệm vụ được giao một cách
          chi tiết hoặc thực thi nhiệm vụ dựa vào sự hướng
          dẫn của người khác.`
        };
        break;
      default:
        result = {
          name: 'Đã xảy ra lỗi. Hệ thống không thể tính ra kết quả',
          description: ''
        };
        break;
    }
    return (
      <div className="info">
        <h5>Kết quả bạn thuộc vào nhóm:</h5>
        <h3 className="text-center"><Badge variant="danger">{result.name}</Badge></h3>
        <p>{result.description}</p>
      </div>
    );
  };
  const drawChart = () => {
    const R = get(score, 1, 0);
    const I = get(score, 2, 0);
    const A = get(score, 3, 0);
    const S = get(score, 4, 0);
    const E = get(score, 5, 0);
    const C = get(score, 6, 0);
    return (
      <svg className="chart" width="370" height="405">
        <g>
          <text x="30" y={350 - (20 * R)} fontWeight="bold">{R}</text>
          <rect x="10" width="50" y={360 - (20 * R)} height={20 * R} stroke="#b8daff" fill="#cce5ff" />
          <text x="30" y="395" fontWeight="bold">R</text>
        </g>
        <g>
          <text x="90" y={350 - (20 * I)} fontWeight="bold">{I}</text>
          <rect x="70" width="50" y={360 - (20 * I)} height={20 * I} stroke="#d6d8db" fill="#e2e3e5" />
          <text x="90" y="395" fontWeight="bold">I</text>
        </g>
        <g>
          <text x="150" y={350 - (20 * A)} fontWeight="bold">{A}</text>
          <rect x="130" width="50" y={360 - (20 * A)} height={20 * A} stroke="#c3e6cb" fill="#d4edda" />
          <text x="150" y="395" fontWeight="bold">A</text>
        </g>
        <g>
          <text x="210" y={350 - (20 * S)} fontWeight="bold">{S}</text>
          <rect x="190" width="50" y={360 - (20 * S)} height={20 * S} stroke="#f5c6cb" fill="#f8d7da" />
          <text x="210" y="395" fontWeight="bold">S</text>
        </g>
        <g>
          <text x="270" y={350 - (20 * E)} fontWeight="bold">{E}</text>
          <rect x="250" width="50" y={360 - (20 * E)} height={20 * E} stroke="#ffeeba" fill="#fff3cd" />
          <text x="270" y="395" fontWeight="bold">E</text>
        </g>
        <g>
          <text x="330" y={350 - (20 * C)} fontWeight="bold">{C}</text>
          <rect x="310" width="50" y={360 - (20 * C)} height={20 * C} stroke="#bee5eb" fill="#d1ecf1" />
          <text x="330" y="395" fontWeight="bold">C</text>
        </g>
        <g>
          <line x1="10" x2="360" y1="375" y2="375" stroke="#dc3545" />
        </g>
      </svg>
    );
  };
  return (
    <div className="holland-result">
      <p ref={endPageRef} />
      <Row>
        <Col lg={12}>
          <h3 className="text-center"><Badge variant="info">KẾT QUẢ</Badge></h3>
        </Col>
        <Col md={6} className="text-center">
          {renderResult()}
        </Col>
        <Col className="text-center" md={6}>
          {drawChart()}
        </Col>
      </Row>

      <Table responsive striped bordered hover className="sample-result">
        <tbody>
          <tr>
            <td className="text-center">
              <p>Realistic</p>
              <b>Nhóm 1: Nhóm Kỹ Thuật - Người hành động</b>
            </td>
            <td className="text-center">
              <p>Investigative</p>
              <b>Nhóm 2: Nhóm Nghiên cứu - Người tư duy</b>
            </td>
            <td className="text-center">
              <p>Artistic</p>
              <b>Nhóm 3: Nghệ thuật - Người kiến tạo</b>
            </td>
          </tr>
          <tr>
            <td>
              Đây là những người thích vận động thể thao hoặc
              có khả năng làm việc tốt với máy móc, vật thể,
              công cụ, cây cảnh hoặc con vật, hoặc thích làm
              việc ngoài trời.
            </td>
            <td>
              Đây là những người thích quan sát, học hỏi, tìm
              hiểu, tra cứu, phân tích, đánh giá và giải quyết vấn
              đề.
            </td>
            <td>
              Đây là những người có khả năng nghệ thuật, cải
              tiến, trực giác và thích làm việc trong các tình
              huống không có kế hoạch trước như dùng trí
              tưởng tượng và sáng tạo.
            </td>
          </tr>
          <tr>
            <td className="text-center">
              <p>Social</p>
              <b>Nhóm 4: Nhóm Xã Hội - Người giúp đỡ</b>
            </td>
            <td className="text-center">
              <p>Enterprising</p>
              <b>Nhóm 5: Quản lý - Người thuyết phục</b>
            </td>
            <td className="text-center">
              <p>Conventional</p>
              <b>Nhóm 6: Nghiệp vụ - Người sắp xếp</b>
            </td>
          </tr>
          <tr>
            <td>
              Đây là những người thích làm việc với con người,
              thích soi sáng, giúp đỡ, truyền đạt thông tin, huấn
              luyện hoặc chữa trị cho người khác hoặc có kỹ
              năng về ngôn ngữ.
            </td>
            <td>
              Đây là những người thích làm việc với con người,
              thích ảnh hưởng, thuyết phục, thể hiện, lãnh đạo
              hoặc quản lý con người vì các mục tiêu của tổ
              chức hoặc lợi ích kinh tế.
            </td>
            <td>
              Đây là những người thích làm việc với dữ liệu, có
              kỹ năng làm việc với con số và công việc lưu trữ,
              văn thư, thực hiện nhiệm vụ được giao một cách
              chi tiết hoặc thực thi nhiệm vụ dựa vào sự hướng
              dẫn của người khác.
            </td>
          </tr>
        </tbody>
      </Table>
      <div className="text-center">
        <Button onClick={handleBack} variant="success">Quay về trang chủ</Button>
      </div>
    </div>
  );
};

HollandResult.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  score: PropTypes.object.isRequired
};

export default HollandResult;
